import { CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';

import { withContextualAttributeTemplate } from './contextual-attribute';

/**
 * add account contextual in front of campaign in MCC recommendation inline view.
 * @param {string} opportunityId - opportunity Id
 * @param {string} accountName - account Name
 * @param {number} accountId - account Id
 * @param {string} originEntity - entity contextual attribute in single account version
 * @return {string} entity string with account name prepended
 */
export const prependAccountAttribute = ({
  opportunityId,
  accountName,
  accountId,
  originEntity,
}) => {
  const accountEntity = withContextualAttributeTemplate({
    opportunityId,
    entityName: accountName,
    entityId: accountId,
    entityType: CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
    status: 'false',
    isExpandingView: true,
  });

  return `${accountEntity} > ${originEntity}`;
};
